<template>
  <section class="m-t-lg wrapper-md animated fadeIn" id="content">
    <div class="container aside-xxxl block m-t-lg">
      <br><br>
      <section class="block m-t-lg">
        <div class="text-center pos-rlt">
          <h1 class="text-black font-thin" style="font-size: 72px;">OOPS!</h1>
          <h3 class="h2 font-thin text-black" style="margin-bottom: 72px;font-size: 20px;">
            Sorry! This page no longer exists.
          </h3>
          <a class="btn btn-dark m-t-lg" href="/">
            <span class="text-white text-u-c" style="padding-left: 20px;padding-right: 20px;">BACK TO HOME</span>
          </a>
        </div>
      </section>
      <span class="h4 block m-t-lg hide"></span>
    </div>
  </section>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped>

</style>
